document.addEventListener("DOMContentLoaded", () => {
    const headings = document.querySelectorAll(".article-template__content h2");
    const menu = document.getElementById("faq-menu");
    const searchInput = document.getElementById("faq-menu-search");
    const questions = document.querySelectorAll(".accordion-button-text");

    console.log(headings);
    console.log('couocuicuicucouco');
    
    initMenu(headings, menu);
    initSearch(searchInput, questions, headings);
});

function initMenu(headings, menu) {
    headings.forEach((heading, index) => {
        const id = `heading-${index}`;
        heading.id = id;

        const listItem = createMenuItem(id, heading.textContent);
        menu.appendChild(listItem);
    });
}

function createMenuItem(id, text) {
    const li = document.createElement("li");
    const a = document.createElement("a");
    a.href = `#${id}`;
    a.textContent = formatText(text);
    a.classList.add(
        "tw-py-2",
        "tw-transition-colors",
        "tw-duration-500",
        "hover:tw-text-white",
        "hover:tw-bg-light-black",
        "tw-text-description-mobile",
        "lg:tw-text-description",
        "tw-block",
        "tw-w-fit",
        "tw-px-4",
        "tw-border",
        "tw-rounded-full",
        "tw-border-light-black",
        "tw-text-light-black",
        "tw-whitespace-nowrap"
      );
    a.addEventListener("click", (event) => smoothScroll(event, id));
    
    li.appendChild(a);
    return li;
}

function smoothScroll(event, id) {
    event.preventDefault();
    const target = document.getElementById(id);
    const offset = 250;
    const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: targetPosition, behavior: "smooth" });
}

function initSearch(searchInput, questions, headings) {
    searchInput.addEventListener("input", () => {
        const query = searchInput.value.toLowerCase();
        filterQuestions(questions, query);
        toggleSectionsVisibility(headings);
        toggleNoResultsVisibility();
    });
}

function filterQuestions(questions, query) {
    questions.forEach(question => {
        const text = question.textContent.toLowerCase();
        const parentContainer = question.closest(".accordion-button-container");
        parentContainer.style.display = text.includes(query) ? "block" : "none";
    });
}

function toggleSectionsVisibility(headings) {
    headings.forEach((heading) => {
        const faqSection = heading.closest(".article-template__content");
        if (!faqSection) return;

        const allHidden = [...faqSection.querySelectorAll(".accordion-button-text")].every(question => {
            const parent = question.closest(".accordion-button-container");
            return window.getComputedStyle(parent).display === "none";
        });

        heading.closest(".shopify-section").style.display = allHidden ? "none" : "block";
    });
}

function toggleNoResultsVisibility() {
    const containers = document.querySelectorAll(".accordion-button-container");

    const allHidden = Array.from(containers).every(container => {
        return window.getComputedStyle(container).display === "none";
    });


    const noResults = document.querySelector("#no-results-message");
    if (noResults) {
        if (allHidden) {
            console.log(allHidden);
            noResults.classList.remove("tw-hidden");
        } else {
            console.log('222');
            noResults.classList.add("tw-hidden");
        }
    }
}

function formatText(text) {
    text = text.toLowerCase().trim();
    return text.charAt(0).toUpperCase() + text.slice(1);
}